import React from 'react'
import { RootState } from '@/store/configureStore'
import { useDispatch, useSelector } from 'react-redux'
import { handleDueAmountModal } from '@/store/reducers/modalSlice'

export const useDueAmountModal = () => {
  const dispatch = useDispatch()
  const { dueAmount } = useSelector((state: RootState) => state.modalSlice)
  const { isDueAmountModalOpen, boxType, itemFees, trackingNumber } = dueAmount

  const closeDueAmountModal = () => {
    dispatch(handleDueAmountModal({ open: false }))
  }

  const openDueAmountModal = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    itemFees: ItemFees,
    boxType: string,
    trackingNumber: string
  ) => {
    event.preventDefault()
    dispatch(handleDueAmountModal({ open: true, itemFees, boxType, trackingNumber }))
  }

  return {
    boxType,
    itemFees,
    trackingNumber,
    openDueAmountModal,
    closeDueAmountModal,
    isDueAmountModalOpen
  }
}
